<div class="matp-table-actions tw-ml-4 tw-mb-4">
  <div class="tw-flex tw-items-center tw-justify-between">
    <div class="tw-flex tw-items-center">
      <div class="tw-flex tw-flex-col tw-text-[0.8em]">
        <app-datetime-range-picker
          type="date"
          [formGroup]="dateRangeFormGroup"
          [maxRangeMonths]="maxRangeMonths"
          startFormControlName="historyFrom"
          endFormControlName="historyTo"
        ></app-datetime-range-picker>
      </div>

      <div class="tw-ml-4">
        <button
          mat-raised-button
          color="primary"
          class="tw-text-lg"
          [disabled]="dateRangeFormGroup.invalid"
          (click)="searchRequested.emit()"
        >
          <mat-icon>search</mat-icon>
          <span>検索</span>
        </button>
      </div>
    </div>

    <div class="tw-flex tw-justify-end">
      <button
        mat-raised-button
        color="primary"
        class="tw-text-lg"
        (click)="exportRequested.emit()"
      >
        <mat-icon>download</mat-icon>
        <span>エクスポート</span>
      </button>
    </div>
  </div>
</div>

<mat-card class="matp-card">
  <app-shipment-info-list-table
    [shipmentList]="shipmentList"
    [routeLoading]="routeLoading"
    [resultHistoryFrom]="resultHistoryFrom"
    [resultHistoryTo]="resultHistoryTo"
    [defaultFilters]="defaultFilters"
    [editableRole]="editableRole"
    [showSensorAlertStartTime]="false"
    (opened)="opened.emit($event)"
    (statusGottenReady)="statusGottenReady.emit($event)"
    (statusInterrupted)="statusInterrupted.emit($event)"
  ></app-shipment-info-list-table>
</mat-card>
